export default "__VITE_ASSET__D$zzEKuX__"